

export function implantAppMini(container, data) {

    if(!container) return;

    let miniSliderContainer = document.getElementById('widereview-swiper-containerSmallProductPage');

    if (!miniSliderContainer) return;

    function eraseTextWrap (container) {
        let textReviews = container.querySelectorAll('.widereview-reviewItem-review');
        textReviews.forEach(function (text) {
            let children = text.querySelectorAll('br');
            children.forEach(function (child) {
                child.remove();
            })
        })
    }
    eraseTextWrap(container);

    function removeImg () {
        let arr = miniSliderContainer.querySelectorAll('.widereview-thumbnail');
        let imges = Array.from(arr);

        const minContainersWidth = 440;
        let width= parseInt(window.getComputedStyle(miniSliderContainer).width);

        imges.forEach(function (img) {
            /*if (width < minContainersWidth) {
                img.style.display = 'none';
            } else {
                img.style.display = 'flex';
            }*/

        })
    }

    removeImg ();

    window.addEventListener("resize", function () {
        removeImg();
    });
}
